export const kindToQuery = {
  chart: ['patients'],
  fax: ['archivedFaxes', 'draftFaxes', 'inboundFaxes', 'outboundFaxes'],
  invoice: ['invoice-tags', 'invoices', 'internal_invoices', 'external_invoices'],
  default: ['appointment']
};
